module.exports = __webpack_public_path__ + "img/14.782c3d46.jpg";